import QRCode from 'qrcode.react';
import React from 'react'

export default function QRBlank() {
    const currentUrl = window.location.hostname;
    const qrUrl = `https://${currentUrl}/blankpage`
  return (
    <div class="qr-display-image">
            <QRCode
                id="bmsQE"
                value={qrUrl}
                level={"H"}
                size={400}
                includeMargin={true}
            />
        </div>
  )
}
